import { TemplateEnd } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

/**
 * Save template configuratio
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const saveTemplate = async (data: QueryTemplateData): Promise<any> =>
    APIManager.sendPost(TemplateEnd.SAVE_TEMPLATE, data, true, {}, {}, axios);

/**
 * Sends a GET request to retrieve the template
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getTemplate = async (data: SingleTemplateData): Promise<any> =>
    APIManager.sendGet(
        `${TemplateEnd.GET_TEMPLATE}/${data.templateId}`,
        true,
        {},
        {},
        axios
    );
/**
 * Sends a POST request to share template with other user.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const sharedTemplate = async (data: ShareTemplateData): Promise<any> =>
    APIManager.sendPost(
        `${TemplateEnd.SHARED_TEMPLATE}`,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a PATCH request to save template to all user.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const saveGloballyTemplate = async (data: SingleTemplateData): Promise<any> =>
    APIManager.sendPatch(
        `${TemplateEnd.SAVE_GLOBALLY_TEMPLATE}`,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a PATCH request to save template to all user.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const saveSavedTemplate = async (data: SingleSavedTemplate): Promise<any> =>
    APIManager.sendPost(
        `${TemplateEnd.SAVED_TEMPLATE}`,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a PATCH request to save template to all user.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const resetSavedTemplate = async (
    data: SingleResetTemplateData
): Promise<any> =>
    APIManager.sendPatch(
        `${TemplateEnd.RESET_TEMPLATE}`,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a PATCH request to reset template to global saved template.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const resetGloballyTemplate = async (data: ResetTemplateData): Promise<any> =>
    APIManager.sendPatch(
        `${TemplateEnd.RESET_GLOBALLY_TEMPLATE}`,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a PATCH request to reset template to global saved template.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const resetCustomTemplate = async (
    data: ResetCustomTemplateData
): Promise<any> =>
    APIManager.sendPatch(
        `${TemplateEnd.RESET_CUSTOM_TEMPLATE}`,
        data,
        true,
        {},
        {},
        axios
    );

/**
 * Sends a DELETE request to remove template data.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const deleteTemplate = async (data: SingleTemplateData): Promise<any> =>
    APIManager.sendDelete(
        `${TemplateEnd.DELETE_TEMPLATE}/${data.templateId}`,
        true,
        {},
        {},
        axios
    );
/**
 * Sends a PATCH request to retrieve the specific dashboard template.
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const patchTemplateDashboard = async (data: SharedTemplateData): Promise<any> =>
    APIManager.sendGetWithBody(
        TemplateEnd.PATCH_TEMPLATE_DASHBOARD,
        data,
        true,
        axios
    );

/**
 * Sends a GET request to retrieve the members
 * @param {any} offset - The request offset.
 * @param {any} limit - The request limit.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getMembers = async (offset: number, limit: number): Promise<any> => {
    const url = `${TemplateEnd.GET_MEMBERS}?offset=${offset}&limit=${limit}`;
    return APIManager.sendGet(url, true, {}, {}, axios);
};

/**
 * Sends a POST request to share the template
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const shareTemplate = async (data: SharedTemplateData): Promise<any> =>
    APIManager.sendPost(TemplateEnd.SHARE_TEMPLATE, data, true, {}, {}, axios);

/**
 * Sends a PATCH request to accept/reject the shared template
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const shareTemplateInvite = async (data: QueryTemplateData): Promise<any> =>
    APIManager.sendPatch(
        TemplateEnd.SHARE_TEMPLATE_INVITE,
        data,
        false,
        {},
        {},
        axios
    );

/**
 * Sends a GET request to check invitation of shared template
 * @param {any} data - The request data.
 * @returns {Promise<any>} The promise that resolves with the response data.
 */
const getShareTemplateInvitation = async (
    data: SharedInvitationData
): Promise<any> =>
    APIManager.sendGetWithBody(
        TemplateEnd.SHARE_TEMPLATE_INVITE,
        data,
        false,
        axios
    );

const getParamsCheckByValue = (
    value: string,
    query: any,
    params: any
): boolean => {
    const {
        binNumber,
        clientName,
        cm9Number,
        completedDate,
        limit,
        loanNumber,
        offset,
        operatorId,
        packetStatus,
        packetType,
        slaDaysLeft,
        sort,
        uploadAge,
        uploadDate,
    } = query;
    if (
        value === 'sort' &&
        typeof sort === 'string' &&
        sort === params[value]
    ) {
        return true;
    }
    if (
        value === 'binNumber' &&
        typeof binNumber === 'string' &&
        binNumber === params[value]
    ) {
        return true;
    }
    if (
        value === 'clientName' &&
        typeof clientName === 'string' &&
        clientName === params[value]
    ) {
        return true;
    }
    if (
        value === 'cm9Number' &&
        typeof cm9Number === 'string' &&
        cm9Number === params[value]
    ) {
        return true;
    }
    if (
        value === 'loanNumber' &&
        typeof loanNumber === 'string' &&
        loanNumber === params[value]
    ) {
        return true;
    }
    if (
        value === 'operatorId' &&
        typeof operatorId === 'string' &&
        operatorId === params[value]
    ) {
        return true;
    }
    if (
        value === 'completedDate' &&
        typeof completedDate === 'string' &&
        completedDate === params[value]
    ) {
        return true;
    }
    if (
        value === 'uploadDate' &&
        typeof uploadDate === 'string' &&
        uploadDate === params[value]
    ) {
        return true;
    }
    if (
        value === 'uploadAge' &&
        typeof uploadAge === 'number' &&
        uploadAge === params[value]
    ) {
        return true;
    }
    if (
        value === 'slaDaysLeft' &&
        typeof slaDaysLeft === 'number' &&
        slaDaysLeft === params[value]
    ) {
        return true;
    }
    if (
        value === 'limit' &&
        typeof limit === 'number' &&
        limit === params[value]
    ) {
        return true;
    }
    if (
        value === 'offset' &&
        typeof offset === 'number' &&
        offset === params[value]
    ) {
        return true;
    }
    if (
        value === 'packetStatus' &&
        Array.isArray(packetStatus) &&
        Array.isArray(params[value]) &&
        packetStatus.sort().join(',') === params[value].sort().join(',')
    ) {
        return true;
    }
    if (
        value === 'packetType' &&
        Array.isArray(packetType) &&
        Array.isArray(params[value]) &&
        packetType.sort().join(',') === params[value].sort().join(',')
    ) {
        return true;
    }
    return false;
};

export const TemplateService = {
    patchTemplateDashboard,
    saveGloballyTemplate,
    sharedTemplate,
    deleteTemplate,
    getTemplate,
    saveTemplate,
    getMembers,
    shareTemplate,
    shareTemplateInvite,
    resetGloballyTemplate,
    resetCustomTemplate,
    getParamsCheckByValue,
    getShareTemplateInvitation,
    saveSavedTemplate,
    resetSavedTemplate,
};
